import { h } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { api } from '../../state/auth.js';
import { useAuth } from '../../hooks/useAuth.js';
import { fetchFeatures } from '../../utils/features.js';

// "Draagt bij aan": the goals an item contributes to (Visie & doelen). Only while that
// feature is visible for this user (services/features.js) — nothing is fetched otherwise.
export function useGoalsFor(type, ids) {
  const auth = useAuth();
  const [map, setMap] = useState({});
  const key = ids.filter(Boolean).join(',');
  useEffect(() => {
    setMap({});
    if (!key) return undefined;
    let stale = false;
    fetchFeatures(`${auth.userId}:${auth.activeClubId}`)
      .then(f => (f.goals ? api(`/api/goals/for?type=${type}&ids=${key}`) : null))
      .then(m => { if (!stale && m) setMap(m); })
      .catch(() => {});
    return () => { stale = true; };
  }, [type, key, auth.userId, auth.activeClubId]);
  return map;
}

export function GoalChips({ goals }) {
  if (!goals?.length) return null;
  return (
    <div style="display:flex;gap:4px;flex-wrap:wrap;margin-top:4px" aria-label="Draagt bij aan">
      {goals.map(g => (
        <a key={g.id} href="/goals" onClick={e => { e.preventDefault(); route('/goals'); }} title="Draagt bij aan dit doel"
          style="font-size:11px;padding:1px 8px;border-radius:10px;background:#ede9fe;color:#5b21b6;text-decoration:none;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">
          🎯 {g.title}
        </a>
      ))}
    </div>
  );
}

// Label for a single item (task or process page)
export default function ItemGoals({ type, id }) {
  const map = useGoalsFor(type, [id]);
  return <GoalChips goals={map[id]} />;
}
